module.exports = __webpack_public_path__ + "static/media/logo-american-taxi.904065ed.jpg";